module.exports = __webpack_public_path__ + "static/s3-oblaci-266f9bbca0206f52137cae2a2ad61831.png";